export const FormFields = {
    REQUESTER_EORI: 'requesterEori',
    MRN: 'mrn',
    TRANSPORT_DOCUMENT_TYPE: 'transportDocumentType',
    TRANSPORT_DOCUMENT_REFERENCE_NUMBER: 'transportDocumentReferenceNumber',
    PRE_LOADING_RISK_ASSESSMENT_STATUS: 'preLoadingRiskAssessmentStatus',
    NOTIFICATIONS: 'notifications',
} as const;

export type FormValues = {
    [FormFields.REQUESTER_EORI]: string | undefined;
    [FormFields.MRN]: string | undefined;
    [FormFields.TRANSPORT_DOCUMENT_TYPE]: string | undefined;
    [FormFields.TRANSPORT_DOCUMENT_REFERENCE_NUMBER]: string | undefined;
    [FormFields.PRE_LOADING_RISK_ASSESSMENT_STATUS]: boolean;
    [FormFields.NOTIFICATIONS]: boolean;
};
